import { gfhAPI } from '../httpClient';

const hasLegacySmartLocks = async (userId: string) => {
  const response = await gfhAPI.get(
    `/smartlock-account/has-legacy-account/${userId}`
  );
  return response.data;
};

export default hasLegacySmartLocks;
